import {Component, Input, Output, OnInit, EventEmitter, OnDestroy} from '@angular/core';
import {RegistriesService} from '../../service';
import {ActivatedRoute, Router} from "@angular/router";
import {faCheck} from "@fortawesome/free-solid-svg-icons/faCheck";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {ClientTypeEnum} from '@amlCore/enums';
import {TerroristSubject} from "../../model/terrorist/terroristSubject.model";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-registry-terrorist-view',
  templateUrl: './terroristView.component.html'
})
export class TerroristViewComponent implements OnInit, OnDestroy {
  @Output() startLoading: any = new EventEmitter<boolean>();
  @Output() finishLoading: any = new EventEmitter<boolean>();
  @Input() hideGoBackBtn = false;
  @Input() isModal = false;
  $destroy = new Subject();

  ClientTypeEnum = ClientTypeEnum;
  item: TerroristSubject;
  icons = {
    check: faCheck
  };
  constructor(private regSrv: RegistriesService,
              private route: ActivatedRoute,
              private _activeModal: NgbActiveModal,
              protected router: Router) {
  }
  isPerson: boolean = false;
  isOrg: boolean = false;

  @Input() id: string;

  ngOnInit() {
    if (this.id) {
      setTimeout(() => {
        this.startLoading.emit(true);
        this.startLoading.complete();
      });
      this.loadList();
    } else {
      this.route.params
        .pipe(takeUntil(this.$destroy))
        .subscribe(params => {
          this.id = params.id;
          this.loadList();
      });
    }
  }

  loadList() {
    this.regSrv.getTerroristById(this.id).pipe(takeUntil(this.$destroy)).subscribe(data => {
      this.item = data;
      this.isPerson = [ClientTypeEnum.INDIVIDUAL_PERSON, ClientTypeEnum.PRIVATE_PRACTITIONER].includes(this.item.uchType);
      this.isOrg = [ClientTypeEnum.LEGAL_ENTITY, ClientTypeEnum.INDIVIDUAL_ENTREPRENEUR].includes(this.item.uchType);
      this.finishLoading.emit(false);
      this.finishLoading.complete();
    });
  }

  closeModal() {
    this._activeModal.dismiss(false);
  }

  ngOnDestroy(): void {
    this.$destroy.next();
    this.$destroy.complete();
  }
}
